import {
    createStyles,
    Dialog,
    DialogContent,
    DialogTitle,
    makeStyles,
} from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

import { useDeviceSize } from "../../components/hooks";
import { DialogCloseIconButton } from "../buttons";
import { RelodeTheme } from "../styles";
import { Text } from "../text";
import { NotificationIcon } from "./notificationIcon";
import { NotificationLevel } from "./types";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            title: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
            },
            titleIcon: {
                display: "flex",
                flexDirection: "row",
                alignItems: "start",
                justifyContent: "space-between",
            },
            content: {
                padding: "8px 24px 40px 24px",
            },
            iconOffset: {
                fontSize: 56,
                marginLeft: 42,
                marginTop: 16,
                marginBottom: theme.spacing(2),
            },
            iconCentered: {
                fontSize: 56,
                marginTop: 16,
                marginBottom: theme.spacing(2),
            },
        }),
    { name: "ModalNotification" }
);

interface ModalNotificationProps {
    level: NotificationLevel;
    title: string;
    message: React.ReactNode;
    notificationKey: string;
    onClose?: (key: string) => void;
    canClose?: boolean;
    customIcon?: React.ReactElement<SvgIconProps>;
}

export const ModalNotification = (props: ModalNotificationProps) => {
    const {
        canClose = true,
        title,
        level,
        message,
        notificationKey,
        customIcon,
        onClose = (...args) => {
            /* noop */
        },
    } = props;
    const classes = useStyles({});
    const device = useDeviceSize();

    const [open, setOpen] = React.useState(true);

    const handleClose = () => {
        setOpen(false);
        onClose(notificationKey);
    };

    return (
        <Dialog
            data-cy="notificationModal"
            open={open}
            fullWidth={device == "desktop" ? true : false}
            maxWidth={device == "desktop" ? "sm" : undefined}
            fullScreen={device === "mobile"}
        >
            <DialogTitle disableTypography={true} className={classes.title}>
                <div className={classes.titleIcon}>
                    <div></div>
                    <NotificationIcon
                        level={level}
                        size="small"
                        className={
                            canClose ? classes.iconOffset : classes.iconCentered
                        }
                        customIcon={customIcon}
                    />
                    {canClose ? (
                        <DialogCloseIconButton onClick={handleClose} />
                    ) : (
                        <div></div>
                    )}
                </div>
                <Text variant="h2" align="center">
                    {title}
                </Text>
            </DialogTitle>
            <DialogContent className={classes.content}>
                <Text variant="body1" align="center">
                    {message}
                </Text>
            </DialogContent>
        </Dialog>
    );
};
